import React, { Component } from 'react';
import moment from 'moment';
import cn from 'classname';
import find from 'lodash/find';

const isRocket = process.env.CPA_ENV === 'rocket';

const Table = ({
	row, internalContacts, intl, listOfRefererTypes, extendedData, isFullDataShowed, toggleFullData
}) => (
	<tr className="details">
		<td colSpan="11">
			<div className="details-wrap">
				<div className="details-wrap__item">
					<h3 className="icon-details-info">{intl('Conversions details')}</h3>
					<table className="simple-table details-wrap__item-table">
						<tbody className="simple-table__body">
							<tr>
								<td className="title">{intl('Campaign')}</td>
								<td className="value">{row.campaign || '-'}</td>
							</tr>
							<tr>
								<td className="title">{intl('Campaign ID')}</td>
								<td className="value">{row.campaign_id || '-'}</td>
							</tr>
							<tr>
								<td className="title">{intl('SID')}</td>
								<td className="value">{row.sid}</td>
							</tr>
							<tr>
								<td className="title">{intl('Landing')}</td>
								<td className="value">{row.landing || '-'}</td>
							</tr>
							<tr>
								<td className="title">{intl('Transit page')}</td>
								<td className="value">{row.transit || '-'}</td>
							</tr>
							<tr className="text">
								<td className="title">{intl('Landing link')}</td>
								<td className="value">{row.referer || 'none'}</td>
							</tr>
							<tr className="text">
								<td className="title">{intl('Referer')}</td>
								<td className="value">{row.click_referer || 'none'}</td>
							</tr>
							<tr className="text">
								<td className="title">{intl('Referer type')}</td>
								<td className="value">{getFromListByValue(listOfRefererTypes, row.referer_type) || 'none'}</td>
							</tr>
							<tr>
								<td className="title">{ intl('Client_language') }</td>
								<td className="value wrap">{ row.client_language }</td>
							</tr>
							<tr>
								<td className="title">{ intl('Сrm id') }</td>
								<td className="value wrap">{ row.crm_id }</td>
							</tr>
							<tr>
								<td className="title">{ intl('Comment') }</td>
								<td className="value wrap">{ row.extra_fields && row.extra_fields.comment }</td>
							</tr>
							{
								!isRocket &&
							<tr>
								<td className="title">{ intl('Request body') }</td>
								<td className="value wrap">
									<span
										className={cn(!isFullDataShowed && 'long-text-container-ellipsis', 'long-text-container')}
										onClick={toggleFullData}
									>
										{ extendedData && JSON.stringify(extendedData.metadata) }
									</span>
								</td>
							</tr>
							}
						</tbody>
					</table>
				</div>
				<div className="details-wrap__item">
					<h3 className="icon-details-phone">{intl('Call details')}</h3>
					<table className="details-wrap__item-table">
						<tbody>
							<tr>
								<td className="title">{ intl('Calls count') }</td>
								<td className="value">{ row.calls_count || '-' }</td>
							</tr>
							<tr>
								<td className="title">{ intl('First called date') }</td>
								<td className="value">
									{row.first_called_at
										?
										[
											moment(row.first_called_at).format('DD.MM.YYYY'),
											moment(row.first_called_at).format('HH:mm:ss')
										].join(' ')
										:
										'-'}
								</td>
							</tr>
							<tr>
								<td className="title">{intl('Status changed date')}</td>
								<td className="value">
									{row.status_changed_at
										?
										[
											moment(row.status_changed_at).format('DD.MM.YYYY'),
											moment(row.status_changed_at).format('HH:mm:ss')
										].join(' ')
										:
										'-'}
								</td>
							</tr>
							{ row.cancellation_reason && (
								<tr>
									<td className="title">{intl('Cancellation reason')}</td>
									<td className="value">{intl(row.cancellation_reason)}</td>
								</tr>
							)}

							<tr>
								<td className="title">{ intl('Is redeemed') }</td>
								<td className="value wrap">{ row.is_redeemed ? intl('redeemed') : '-' }</td>
							</tr>

							<tr>
								<td className="title">{ intl('Contacts from landing') }</td>
								<td className="value wrap">{ internalContacts || '-' }</td>
							</tr>
							<tr>
								<td className="title">{ intl('Contacts from CRM') }</td>
								<td className="value wrap">{ row.contacts || '-' }</td>
							</tr>

							<tr>
								<td className="title">{ intl('Gender / Age') }</td>
								<td className="value wrap">{ row.client_gender || '-' } / { row.client_age || '-' }</td>
							</tr>

							<tr>
								<td className="title">{ intl('Is fraud') }</td>
								<td className="value wrap">{ row.is_fraud ? '+' : '-' }</td>
							</tr>
							<tr>
								<td className="title">{ intl('Country_code') }</td>
								<td className="value wrap">{ row.country_code }</td>
							</tr>
							<tr>
								<td className="title">{ intl('Traffic source') }</td>
								<td className="value wrap">{ row.traffic_source }</td>
							</tr>
							<tr>
								<td className="title">{ intl('Chatbot history') }</td>
								<td className="value wrap">
									<span
										className={cn(!isFullDataShowed && 'long-text-container-ellipsis', 'long-text-container')}
										onClick={toggleFullData}
									>
										{
											row.chatbot_history && typeof row.chatbot_history !== 'string'
												? JSON.stringify(row.chatbot_history)
												: row.chatbot_history
										}
									</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</td>
	</tr>
);

class TableContainer extends Component {
	constructor(props) {
		super(props);
		this.state = { isFullDataShowed: false };
		this.toggleFullData = this.toggleFullData.bind(this);
	}
	toggleFullData() {
		this.setState(state => ({ isFullDataShowed: !state.isFullDataShowed }));
	}
	render() {
		return <Table
			{...this.props}
			toggleFullData={this.toggleFullData}
			isFullDataShowed={this.state.isFullDataShowed}
		/>;
	}
}

export default TableContainer;

const getFromListByValue = (list, value) => {
	return find(list, { id: value }) ? find(list, { id: value }).text : null;
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/table/conversions/details-table.js